import React from 'react';
import { Row, Col, Image } from '@thd-olt-component-react/core-ui';
import { EXP_ROUTES, tradeTypeIconMap } from '../../../../utils/constants';
import PageHeader from '../../../../components/common/PageHeader/PageHeader';
import { generateImageSource } from '../../../../utils/generateImageSource';
import GoBackNavLink from '../../../../components/common/GoBackNavLink';

export const JobTemplateDetailsHeader = ({ tradeType, yearsOfExperience }) => {
  const backToObj = {
    backTo: 'Job Templates',
    backToUrl: EXP_ROUTES.JOB_TEMPLATES
  };

  return (
    <>
      <PageHeader>Path to Pro</PageHeader>
      <Row>
        <Col xs={12}>
          <GoBackNavLink backToStr={backToObj.backTo} fallbackUrl={backToObj.backToUrl} noRefresh data-testid="job-template-details-nav-link" />
          <div className="ptp-job-template__title">
            <Image
              src={generateImageSource(`/images/v1/path-to-pro/tradeTypes/${tradeTypeIconMap?.[tradeType] || 'residentialRemodeling'}.svg`)}
              className="ptp-job-template__template-icon"
              alt="trade icon"
            />

            {yearsOfExperience?.substring(0, yearsOfExperience.search(/\d/))} {tradeType} Template
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="ptp-job-template__details-header">
          <div data-testid="templateDetailsHeaderText">
            Our {yearsOfExperience?.substring(0, yearsOfExperience.search(/\d/))} {tradeType || 'job'} template provides a general job description and required experience typical for {tradeType || ''} jobs at this level. Click “Use Template” to create a job using this template, or copy the template below.
            Job templates are meant as <b>starting points</b>. You should <b>always edit and change a template</b> to meet your unique job needs.
          </div>
        </Col>
      </Row>
    </>
  );
};
